import styled from 'styled-components';

export const AddFilterContainer = styled.div`
  display: flex;
`;
